import React from 'react';

export const CorporateClientsSection = ({ t, clients }) => {
  return (
    <section id="clients" className="py-12 sm:py-20 bg-white" data-testid="home-clients-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" data-testid="home-clients-title">{t('clients.title')}</h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600" data-testid="home-clients-subtitle">{t('clients.subtitle')}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6" data-testid="home-clients-grid">
          {clients.map((client) => (
            <div key={client.name} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:scale-105" data-testid={`home-client-card-${client.name.replace(/\s+/g, '-').toLowerCase()}`}>
              <img
                src={client.image}
                alt={client.name}
                className="w-full h-32 sm:h-40 object-cover"
                loading="lazy"
                decoding="async"
                data-testid={`home-client-image-${client.name.replace(/\s+/g, '-').toLowerCase()}`}
                onError={(event) => {
                  event.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect fill='%23ddd' width='200' height='200'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' fill='%23999' dy='.3em'%3E${client.name}%3C/text%3E%3C/svg%3E`;
                }}
              />

              <div className="p-3 sm:p-4 text-center">
                <h4 className="text-sm sm:text-base font-bold text-gray-900" data-testid={`home-client-name-${client.name.replace(/\s+/g, '-').toLowerCase()}`}>{client.name}</h4>
                <p className="text-xs sm:text-sm text-gray-600" data-testid={`home-client-status-${client.name.replace(/\s+/g, '-').toLowerCase()}`}>{t('clients.satisfied')}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
